var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircleXLarge = function SvgCloseCircleXLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3330",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21.657 21.657 10.343 10.343m11.314 0L10.343 21.657"
  })));
};
export default SvgCloseCircleXLarge;